import ServerSideRender from "@wordpress/server-side-render";
import metadata from "./block.json";

<ServerSideRender block={metadata.name} attributes={attributes} />;
